
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';
import CustomerCountryChoice from '../customer_country_choice/index';

class CustomerRedirectAnalytics {
  static showAction() {
    const category = GA_EVENTS.customerRedirect.category;
    const action = GA_EVENTS.customerRedirect.actions.show;
    const label = CustomerCountryChoice.getCustomerTimezone();
    setBehaviourEvent({ category, action, label });
  }
  
  static closeAction() {
    const category = GA_EVENTS.customerRedirect.category;
    const action = GA_EVENTS.customerRedirect.actions.close;

    // @todo: label below taken from merge commits, not sure this is the correct value
    const label = CustomerCountryChoice.getStoreUrl();

    setBehaviourEvent({ category, action, label });
  }
  
  static redirectAction(url) {
    const category = GA_EVENTS.customerRedirect.category;
    const action = GA_EVENTS.customerRedirect.actions.redirect;
    const label = url ? url : CustomerCountryChoice.getCustomerRedirectUrl();

    setBehaviourEvent({ category, action, label });
  }
}
export default CustomerRedirectAnalytics;